
   
    function isTestSsn(ssn: string) {
        const ssnMonth = parseInt(ssn.substring(2, 4));
        if (ssnMonth > 80) {
            return true;
        }
        return false;
    }
    function convertBackToCorrectMonth(ssn: string) {
        const ssnDay = ssn.substring(0, 2);
        const ssnMonth = parseInt(ssn.substring(2, 4)) - 80;
        const ssnRest = ssn.substring(4, 11);
        const ssnMonthPadded = ('0' + ssnMonth).slice(-2);
        return ssnDay + ssnMonthPadded + ssnRest;
    }

    function convertToNormalIfTest(number: string) {
        
        if (isTestSsn(number)) {
           return convertBackToCorrectMonth(number);
        }
        return number;
    }
   
   function isDateValid(date: string) {
        const day = parseInt(date.substring(0, 2)),
            month = parseInt(date.substring(2, 4)),
            monthLengths = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        if (day < 1 || month < 1) {
            return false;
        }

        if (day > monthLengths[month - 1]) {
            return false;
        }

        return true;
    }

    function isDNumber(date: string) {
        const day = parseInt(date.substring(0, 2));

        if (day > 40 && day < 72) {
            return true;
        }
        return false;
    }

    function calculateFirstChecksum(input: string) {
        if (typeof input !== "string") {
            return false;
        }

        if (input.length !== 9) {
            return false;
        }

        const arr = input.split("").map(function (n) {
            return parseInt(n);
        });

        let checksum =
            11
          - ((3 * arr[0]
                + 7 * arr[1]
                + 6 * arr[2]
                + 1 * arr[3]
                + 8 * arr[4]
                + 9 * arr[5]
                + 4 * arr[6]
                + 5 * arr[7]
                + 2 * arr[8]
              )
              % 11
            );

        if (checksum === 10) {
            return false;
        }

        if (checksum === 11) {
            checksum = 0;
        }

        return checksum;
    }

    function calculateSecondChecksum(input: string) {
        if (typeof input !== "string") {
            return false;
        }

        if (input.length !== 10) {
            return false;
        }

        const arr = input.split("").map(function (n) {
            return parseInt(n);
        });

        let checksum =
            11
          - ((5 * arr[0]
                + 4 * arr[1]
                + 3 * arr[2]
                + 2 * arr[3]
                + 7 * arr[4]
                + 6 * arr[5]
                + 5 * arr[6]
                + 4 * arr[7]
                + 3 * arr[8]
                + 2 * arr[9]
              )
              % 11
            );

        if (checksum === 10) {
            return false;
        }

        if (checksum === 11) {
            checksum = 0;
        }

        return checksum;
    }

    export function validateNorwegianSsn(val: string) {
        if (typeof val !== "string") {
            return false;
        }
        const number = val.trim();
        if (number.length !== 11) {
            return false;
        }

      
        if (!/^\d+$/.test(number)) {
            return false;
        }
        
        const ssnOrig = convertToNormalIfTest(number);

        let date = ssnOrig.substring(0, 6);

        if (isDNumber(ssnOrig)) {
            date = (parseInt(date.substring(0, 1), 10) - 4).toString() + date.substring(1, 6);
        }

        if (!isDateValid(date)) {
            return false;
        }

        if (calculateFirstChecksum(number.substring(0, 9)).toString() !== ssnOrig[9]) {
            return false;
        }

        if (calculateSecondChecksum(number.substring(0, 10)).toString() !== ssnOrig[10]) {
            return false;
        }

        return true;
    }
